/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Committedorganisations_Estreturn3Inputs */

const en_coinvestments_report_committedorganisations_estreturn3 = /** @type {(inputs: Coinvestments_Report_Committedorganisations_Estreturn3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est. return`)
};

/**
* | output |
* | --- |
* | "Est. return" |
*
* @param {Coinvestments_Report_Committedorganisations_Estreturn3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_committedorganisations_estreturn3 = /** @type {((inputs?: Coinvestments_Report_Committedorganisations_Estreturn3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Committedorganisations_Estreturn3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_committedorganisations_estreturn3(inputs)
});
export { coinvestments_report_committedorganisations_estreturn3 as "coInvestments_report_committedOrganisations_estReturn" }